import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	generating: {
		id: 'servicedesk-ai-context-common.generation-skeleton.generating',
		defaultMessage: 'Atlassian Intelligence is generating suggestions',
		description: 'Status message displayed while Atlassian Intelligence is generating content',
	},
});
